module.exports = __webpack_public_path__ + "static/media/exitFullScreenIcon.77fc6296.svg";